/**
 * RichText
 *
 * Renders server-sanitized HTML via dangerouslySetInnerHTML.
 * The backend already sanitizes content via an allow-list before saving.
 *
 * Props:
 *   html: string of HTML to render
 *   className: optional extra className on the wrapper
 *   tag: wrapper element tag (default 'div')
 */
function RichText({ html, className = '', tag: Tag = 'div' }) {
  if (!html) return null;
  return (
    <Tag
      className={className || undefined}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

export default RichText;
